(() => {
  'use strict';
  if (window.__jmContactTrackingLoaded) return;
  window.__jmContactTrackingLoaded = true;

  const tag = document.currentScript;
  const measurementId = tag && tag.dataset.analyticsId;
  const recentClicks = new WeakMap();
  const isPreview = () => Boolean(
    window.Shopify && (
      window.Shopify.designMode ||
      (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')
    )
  );

  let sendTag;
  let ownsTag = false;
  const setStatus = (status) => { if (tag) tag.dataset.jmTrackingTag = status; };
  const privacyApi = () => window.Shopify && window.Shopify.customerPrivacy;
  const updateConsent = () => {
    const privacy = privacyApi();
    if (!privacy) return;
    if (ownsTag && sendTag) {
      const marketing = typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed();
      sendTag('consent', 'update', {
        analytics_storage: privacy.analyticsProcessingAllowed() ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied'
      });
    }
  };
  const connectTag = () => {
    const privacy = privacyApi();
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') {
      setStatus('privacy_unavailable');
      return;
    }
    if (!privacy.analyticsProcessingAllowed()) {
      updateConsent();
      setStatus('consent_denied');
      return;
    }
    if (sendTag) { updateConsent(); return; }
    if (typeof window.gtag === 'function') {
      sendTag = window.gtag;
      setStatus('ready');
      return;
    }
    if (Array.isArray(window.dataLayer)) {
      sendTag = function () { window.dataLayer.push(arguments); };
      setStatus('ready');
      return;
    }
    if (!measurementId) { setStatus('tag_id_missing'); return; }
    window.jmContactDataLayer = window.jmContactDataLayer || [];
    sendTag = function () { window.jmContactDataLayer.push(arguments); };
    ownsTag = true;
    updateConsent();
    sendTag('js', new Date());
    sendTag('config', measurementId, { send_page_view: false });
    const loader = document.createElement('script');
    loader.async = true;
    loader.src = 'https://www.googletagmanager.com/gtag/js?id=' +
      encodeURIComponent(measurementId) + '&l=jmContactDataLayer';
    loader.addEventListener('load', () => setStatus('ready'));
    loader.addEventListener('error', () => setStatus('tag_load_failed'));
    setStatus('loading');
    document.head.appendChild(loader);
  };
  const start = () => {
    if (isPreview()) { setStatus('preview_excluded'); return; }
    connectTag();
  };
  document.addEventListener('visitorConsentCollected', start);
  if (privacyApi()) {
    start();
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (error) { setStatus('privacy_unavailable'); return; }
      start();
    });
  } else {
    setStatus('privacy_unavailable');
  }

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.button > 0 || isPreview()) return;
    const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    const link = target && target.closest('a[href]');
    if (!link) return;

    let url;
    try { url = new URL(link.href, window.location.href); } catch { return; }
    const isPhone = url.protocol === 'tel:';
    const isLine = url.protocol === 'https:' && (
      url.hostname === 'lin.ee' ||
      (url.hostname === 'line.me' && /^\/(R\/)?ti\/p(?:\/|$)/.test(url.pathname))
    );
    if (!isPhone && !isLine) return;

    const privacy = privacyApi();
    if (!privacy || !privacy.analyticsProcessingAllowed()) return;

    const now = Date.now();
    if (recentClicks.has(link) && now - recentClicks.get(link) < 1000) return;

    if (!sendTag) connectTag();
    if (!sendTag) return;

    const location = link.closest('[data-jm-contact-location]');
    const area = location ? location.dataset.jmContactLocation :
      link.closest('footer') ? 'footer' :
      link.closest('header') ? 'header' : 'page_content';
    const params = {
      contact_method: isPhone ? 'phone' : 'line',
      contact_location: area,
      link_url: isPhone ? 'tel:' + url.pathname.replace(/[^+\d]/g, '') : url.origin + url.pathname,
      transport_type: 'beacon'
    };
    if (measurementId) params.send_to = measurementId;
    recentClicks.set(link, now);
    sendTag('event', isPhone ? 'click_to_call' : 'click_line', params);
  }, true);
})();
